import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('rapid.StickyE');
    const { locale } = useRouter();
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${css.comp}`,
                triggerHook: 1,
                offset: '150%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
        }
    });

    return (
        <div className={css.comp}>
            <div className="sticky-box">
                <div className={`img-box ${enter ? 'enter' : ''}`}>
                    <EfImg
                        pc={
                            locale === 'jp'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1730686417004/pc_part05.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1729597663539/pc_part05.jpg'
                        }
                        h5={
                            locale === 'jp'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1730686416648/m_part05.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1729597663701/m_part05.jpg'
                        }
                    />
                    <div className={`info ${enter ? 'enter' : ''}`}>
                        <p className="label">{t('label')}</p>
                        <p className="title">{t('title')}</p>
                        <p className="desc">{t('desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
